import ConditionalRender from "components/ConditionalRender";

const MiniQ2Table = ({item, t}) => {
    const SENSORS = {
        0: "A",
        1: "B",
        2: "AB"
    }
    return <>
        <div className="d-inline-block text-center ps-2 pe-3 border-end">
            <div className="fw-medium">{t("confsens")}</div>
            <div>{SENSORS[item.values.confsens]}</div>
        </div>
        <div className="d-inline-block text-center ps-2 pe-3 border-end">
            <div className="fw-medium">{t("confdist")}</div>
            <div>{t(`confdist.${item.values.confdist}`)}</div>
        </div>
         <div className="d-inline-block text-center ps-2 pe-3 border-end">
            <div className="fw-medium">{t("saturation")}</div>
            <div>{item.values.saturation}</div>
        </div>
         <div className="d-inline-block text-center ps-2 pe-3 border-end">
            <div className="fw-medium">{t("hysteresis")}</div>
            <div>{item.values.hysteresis}</div>
        </div>
        <div className="d-inline-block text-center ps-2 pe-3 border-end">
            <table className="table mb-0">
                <thead>
                <tr>
                    <th className="bg-transparent"></th>
                    <th className="bg-transparent">P0</th>
                    <th className="bg-transparent">P1</th>
                    <th className="bg-transparent">P2</th>
                    <th className="bg-transparent">P3</th>
                    <th className="bg-transparent">P4</th>
                    <th className="bg-transparent">P5</th>
                    <th className="bg-transparent">P6</th>
                    <th className="bg-transparent">P7</th>
                    <th className="bg-transparent">P8</th>
                    <th className="bg-transparent">P9</th>
                    <th className="bg-transparent">P10</th>
                    <th className="bg-transparent">P11</th>
                </tr>
                </thead>
                <tbody>
                <ConditionalRender condition={item.values.confdist === 0 || item.values.confdist === 2}>
                    <tr>
                        <td className="bg-transparent">{t(`confdist.0`)}</td>
                        <td className="bg-transparent">{item.values.p0_threshold_s}</td>
                        <td className="bg-transparent">{item.values.p1_threshold_s}</td>
                        <td className="bg-transparent">{item.values.p2_threshold_s}</td>
                        <td className="bg-transparent">{item.values.p3_threshold_s}</td>
                        <td className="bg-transparent">{item.values.p4_threshold_s}</td>
                        <td className="bg-transparent">{item.values.p5_threshold_s}</td>
                        <td className="bg-transparent">{item.values.p6_threshold_s}</td>
                        <td className="bg-transparent">{item.values.p7_threshold_s}</td>
                        <td className="bg-transparent">{item.values.p8_threshold_s}</td>
                        <td className="bg-transparent">{item.values.p9_threshold_s}</td>
                        <td className="bg-transparent">{item.values.p10_threshold_s}</td>
                        <td className="bg-transparent">{item.values.p11_threshold_s}</td>
                    </tr>
                </ConditionalRender>
                <ConditionalRender condition={item.values.confdist === 1 || item.values.confdist === 2}>
                    <tr>
                        <td className="bg-transparent">{t(`confdist.1`)}</td>
                        <td className="bg-transparent">{item.values.p0_threshold_l}</td>
                        <td className="bg-transparent">{item.values.p1_threshold_l}</td>
                        <td className="bg-transparent">{item.values.p2_threshold_l}</td>
                        <td className="bg-transparent">{item.values.p3_threshold_l}</td>
                        <td className="bg-transparent">{item.values.p4_threshold_l}</td>
                        <td className="bg-transparent">{item.values.p5_threshold_l}</td>
                        <td className="bg-transparent">{item.values.p6_threshold_l}</td>
                        <td className="bg-transparent">{item.values.p7_threshold_l}</td>
                        <td className="bg-transparent">{item.values.p8_threshold_l}</td>
                        <td className="bg-transparent">{item.values.p9_threshold_l}</td>
                        <td className="bg-transparent">{item.values.p10_threshold_l}</td>
                        <td className="bg-transparent">{item.values.p11_threshold_l}</td>
                    </tr>
                </ConditionalRender>
                </tbody>
            </table>
        </div>

    </>
}
export default MiniQ2Table